var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({staticClass:"justify-center",attrs:{"label":_vm.label}},'v-chip',{ ..._vm.$attrs },false),{ ..._vm.$listeners }),[(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.iconColor,"left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',{staticClass:"text-overline font-weight-bold"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }